// extracted by mini-css-extract-plugin
export default {"container":"ControllBlock_container__KphXJ","loader":"ControllBlock_loader__2ZBkp","btn":"ControllBlock_btn__V77mt","btn_title":"ControllBlock_btn_title__tV4rI"};